export enum NkrLiaison {    
    GaretHil = 1,
    MattRonin = 2,
    JoeSinacore = 3,
    TommyDalessandro = 4,
    KevinNelson = 5
}